import { SupplierDirectoryRow } from '../../types/advise';

/** The categories an Advise supplier can be given, stored by `value`. */
export const PRODUCT_CATEGORY_OPTIONS = [
  { value: 'CX', label: 'CX (CCaaS)' },
  { value: 'Network', label: 'Network (DIA/SD-WAN)' },
  { value: 'Security', label: 'Security' },
  { value: 'UCaaS', label: 'UCaaS' },
  { value: 'Colocation', label: 'Colocation' }
];

export const productCategoryLabel = (value: string): string =>
  PRODUCT_CATEGORY_OPTIONS.find((option) => option.value === value)?.label ?? value;

/** The categories some directory row carries, each once and sorted, so no filter option gives an empty table. */
export const directoryCategories = (rows: SupplierDirectoryRow[]): string[] =>
  [...new Set(rows.flatMap((row) => row.categories))].sort((a, b) => a.localeCompare(b));
